import { render, staticRenderFns } from "./ProductVariantForm .vue?vue&type=template&id=9466c8fe&"
import script from "./ProductVariantForm .vue?vue&type=script&lang=js&"
export * from "./ProductVariantForm .vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantForm .vue?vue&type=style&index=0&id=9466c8fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports